export default {
      id: "drag-handle-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#drag-handle",
      toString: function () {
        return this.url;
      }
    }